export default "__VITE_ASSET__DgxcgSlL__"